import styled from 'styled-components/macro';
import { Button } from 'ui-component-library';
import colors from '../../../../../theme';
import { FlexNoAlign, FlexJustifyCenter } from '../../../../../shared-styles/flex';
import { TL_TRACKING_ACTIONS, LTL_TRACKING_ACTIONS } from '../../../../../constants';

export const ActionButtonsContainer = styled.div`
  ${FlexNoAlign}
  flex-wrap: wrap;
  background-color: ${(props) => props.theme.palette.custom.lightGray};
  padding: 0 ${(props) => props.theme.spacing(20)};
  padding-bottom: ${(props) => props.theme.spacing(15)};
  padding-top: ${(props) => props.theme.spacing(15)};
  row-gap: ${(props) => props.theme.spacing(10)};
  column-gap: 19px;
`;

export const ActionButton = styled(Button).attrs(({ fieldId }) => ({
  backgroundColor: (fieldId === TL_TRACKING_ACTIONS.bounceLoad || fieldId === LTL_TRACKING_ACTIONS.bounceLoad)
    ? colors.palette.red[100]
    : colors.palette.darkGray[100],
  inActiveColor: (fieldId === TL_TRACKING_ACTIONS.bounceLoad || fieldId === LTL_TRACKING_ACTIONS.bounceLoad)
    ? colors.palette.red[100]
    : colors.palette.gray[100],
}))`
  && {
    font-family: ${({ theme }) => theme.typography.fonts.default};
    font-size: 12px;
    background-color: ${(props) => (props.isActive ? props.backgroundColor : 'transparent')};
    color: ${(props) => (props.isActive ? props.theme.palette.custom.gray : props.inActiveColor)};
    border: 1px solid ${(props) => props.inActiveColor};
    height: 30px;
    flex-basis: 31%;
    padding: ${(props) => props.theme.spacing(5)} ${(props) => props.theme.spacing(10)};
  }

  &&:hover {
    background-color: ${({ fieldId, theme }) => ((fieldId === TL_TRACKING_ACTIONS.bounceLoad || fieldId === LTL_TRACKING_ACTIONS.bounceLoad)
    ? theme.palette.red[50]
    : theme.palette.custom.actionBtnHover)};
    color: ${({ fieldId, theme }) => ((fieldId === TL_TRACKING_ACTIONS.bounceLoad || fieldId === LTL_TRACKING_ACTIONS.bounceLoad)
    ? theme.palette.white
    : theme.palette.custom.gray)};
    border: 1px solid ${({ fieldId, theme }) => ((fieldId === TL_TRACKING_ACTIONS.bounceLoad || fieldId === LTL_TRACKING_ACTIONS.bounceLoad)
    ? theme.palette.red[50]
    : theme.palette.custom.actionBtnHover)};
  }
`;

export const ArrowDown = styled.div`
  width: 0; 
  height: 0; 
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 20px solid ${(props) => props.theme.palette.custom.lightGray};;
`;

export const ArrowContainer = styled.div`
  ${FlexJustifyCenter};
`;

export const LockedOverlay = styled.div`
  height: 100px;
  position: relative;
  background-color: rgba(255, 255, 255, 0.8);
  margin-bottom: -100px;
  padding-top: ${(props) => props.theme.spacing(20)};
`;

export const LockText = styled.p`
  text-align: center
`;

export const LockIconContainer = styled.div`
  ${FlexJustifyCenter}
  padding-bottom: ${(props) => props.theme.spacing(8)};
`;
